/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Story_Analysis_TitleInputs */

const en_gc_story_analysis_title = /** @type {(inputs: Gc_Story_Analysis_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Find the story behind a table.`)
};

const zh_gc_story_analysis_title = /** @type {(inputs: Gc_Story_Analysis_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`找到表格背后的信息。`)
};

/**
* | output |
* | --- |
* | "Find the story behind a table." |
*
* @param {Gc_Story_Analysis_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_story_analysis_title = /** @type {((inputs?: Gc_Story_Analysis_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Story_Analysis_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_story_analysis_title(inputs)
	return zh_gc_story_analysis_title(inputs)
});
export { gc_story_analysis_title as "gc.story.analysis.title" }